


import { Component, Vue } from 'vue-property-decorator';
import CompleteStep from '@/utils/mixins/completeStep';
import ConfContainer from '../../components/ConfContainer/index.vue';
import PageTransitionMode from '@/utils/mixins/pageTransitionMode';
import { namespace } from 'vuex-class';
import { Floor } from '../../utils/api';
import { SelectType } from '../../components/SelectionPanel/SelectionPanel.models';
import { RenderMode } from '../../components/ConfContainer/ConfContainer.models';

const basementModule = namespace('basement');
const configurationModule = namespace('configuration');

@Component({
  mixins: [CompleteStep, PageTransitionMode],
  components: { ConfContainer }
})
export default class Basement extends Vue {
  @basementModule.Getter private floor!: Floor;
  @configurationModule.State private fromNull!: boolean;

  // to make ts enums work in vue template
  private SelectType: typeof SelectType = SelectType;
  private RenderMode: typeof RenderMode = RenderMode;
}
